import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy, Sparkles } from "lucide-react";
import { publicRanking } from "@/lib/api";

export default function Ranking() {
  const [data, setData] = useState(null);

  useEffect(() => {
    publicRanking().then(setData).catch(() => setData({ ranking: [], total_numbers: 0 }));
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFCF7] bg-grain">
      <div className="max-w-3xl mx-auto px-6 py-14 sm:py-20">
        <motion.header
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#7B8B6F] mb-4">Tattoo Studio</p>
          <div className="inline-flex items-baseline gap-1">
            <span className="brand-mark text-5xl sm:text-6xl text-[#2E332C]">Julliet</span>
            <span className="brand-mark text-5xl sm:text-6xl text-[#7B8B6F]">.Ink</span>
          </div>
          <h1 className="font-serif-display text-3xl sm:text-4xl text-[#2E332C] mt-6 font-light">
            Ranking das Sortudas
          </h1>
          <p className="text-sm text-[#5C6658] mt-3 max-w-md mx-auto">
            Cada tatuagem aqui rende um número da sorte. Quem acumular mais, tem mais chance no próximo sorteio. ✨
          </p>
        </motion.header>

        {!data ? (
          <p className="text-center text-[#5C6658]">Carregando…</p>
        ) : data.ranking.length === 0 ? (
          <div className="elegant-card p-12 text-center">
            <Sparkles className="w-10 h-10 text-[#C4A77D] mx-auto mb-4" />
            <p className="font-serif-display text-2xl text-[#2E332C]">Em breve o ranking aparece aqui</p>
            <p className="text-sm text-[#5C6658] mt-2">Faça sua primeira tatuagem e garanta seu número.</p>
          </div>
        ) : (
          <motion.ol
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-3"
            data-testid="public-ranking-list"
          >
            {data.ranking.map((r, i) => {
              const isPodium = i < 3;
              return (
                <motion.li
                  key={r.client_id}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.05 }}
                  className={`elegant-card p-5 sm:p-6 flex items-center gap-5 ${
                    isPodium ? "ring-1 ring-[#C4A77D]/40" : ""
                  }`}
                >
                  <div className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-serif-display text-2xl ${
                    i === 0 ? "bg-[#C4A77D] text-white" : i === 1 ? "bg-[#D4C9A8] text-[#5C6658]" : i === 2 ? "bg-[#E8E4D9] text-[#7B5E2E]" : "bg-[#F1EEE3] text-[#5C6658]"
                  }`}>
                    {i + 1}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-serif-display text-xl sm:text-2xl text-[#2E332C] truncate">{r.client_name}</p>
                    <div className="flex flex-wrap gap-1.5 mt-2">
                      {r.numbers.slice(0, 8).map((n) => (
                        <span key={n} className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-[#F4E8D6]/60 text-[#7B5E2E] border border-[#C4A77D]/30">
                          #{n}
                        </span>
                      ))}
                      {r.numbers.length > 8 && (
                        <span className="text-[10px] text-[#5C6658]">+{r.numbers.length - 8}</span>
                      )}
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <p className="font-serif-display text-3xl text-[#7B8B6F]">{r.total_numbers}</p>
                    <p className="text-[10px] uppercase tracking-wider text-[#5C6658]">números</p>
                  </div>
                  {isPodium && <Trophy className="w-5 h-5 text-[#C4A77D] hidden sm:block" />}
                </motion.li>
              );
            })}
          </motion.ol>
        )}

        <footer className="text-center mt-16 text-xs text-[#5C6658] uppercase tracking-[0.25em]">
          {data?.total_numbers || 0} números em jogo
        </footer>
      </div>
    </div>
  );
}
